import React from 'react';
import { useMediaQuery } from 'react-responsive';
import Header from '../components/Header'
import Footer from '../components/Footer'
import bgPic1 from '../assets/images/background1.svg'
import styles from './Joinus.module.css'; 
import {IdcardTwoTone} from '@ant-design/icons';


function JobProfiles() {
  return (
    <section className={styles.container1}>
      <div className={styles.content1}>
        <h2 className={styles.title1}>
          What job profiles are we currently looking for?
        </h2>
        <p className={styles.description1}>
        Join our compact team and grow your career with us—while we may be small in size, the opportunities we offer are vast and ready for you to seize!
        </p>
      </div>
    </section>
  );
}

const JobCard1 = () => {
  return (
    <article className={styles.card2}>
      <IdcardTwoTone style={{ fontSize: '66px', color: 'blue' }} />
      <h2 className={styles.title2}>Product Selection Intern</h2>
      <p className={styles.description2}>
      Assist the product selection team in conducting market research, analyzing consumer demand, and identifying potential products. Support supply chain and inventory management to ensure timely and accurate product availability.
      </p>
      <div className={styles.buttonContainer}>
        <Button
          mailto="mailto:hr@neohotech.com?subject=Joining%20Your%20Team&body=Lead%20UI%20Designer%20Position"
        >
          Join Us
        </Button>
      </div>
    </article>
  );
};

const JobCard2 = () => {
  return (
    <article className={styles.card2}>
      <IdcardTwoTone style={{ fontSize: '66px', color: '#eb2f96' }} />
      <h2 className={styles.title2}>E-commerce Operations</h2>
      <p className={styles.description2}>
      Assist the e-commerce team with daily operations, including store management, promotional activity planning and execution. Help optimize user experience and boost sales.
      </p>
      <div className={styles.buttonContainer}>
        <Button
          mailto="mailto:hr@neohotech.com?subject=Joining%20Your%20Team&body=Content%20Creator%20Position"
        >
          Join Us
        </Button>
      </div>
    </article>
  );
};

const JobCard3 = () => {
  return (
    <article className={styles.card2}>
      <IdcardTwoTone style={{ fontSize: '66px', color: '#08c' }} />
      <h2 className={styles.title2}>New Media Operations</h2>
      <p className={styles.description2}>
      Responsibilities: Assist the new media team in planning and posting social media content. Keep up with trending topics and create relevant content to boost brand exposure and engagement.
      </p>
      <div className={styles.buttonContainer}>
        <Button
          mailto="mailto:hr@neohotech.com?subject=Joining%20Your%20Team&body=Product%20Designer%20Position"
        >
          Join Us
        </Button>
      </div>
    </article>
  );
};



function Button({ primary, children, mailto }) {
  const handleClick = () => {
    if (mailto) {
      window.location.href = mailto;  // If the mailto prop is passed, open the mail app
    }
  };

  return (
    <button
      className={primary ? styles.primaryButton : styles.secondaryButton}
      onClick={handleClick}  // Attach the handleClick event to the button
    >
      {children}
    </button>
  );
}



function DeskInfSection() {
  return (
    <section className={styles.container}>
      <img 
        loading="lazy" 
        src={bgPic1}
        className={styles.backgroundImage} 
        alt="backgroundImage"
      />
      <h1 className={styles.title}>
      Join Our Journey: Share the Culture of Japan with Your Followers!
      </h1>
      <p className={styles.description}>
      Explore and showcase Japan's rich culture, delicious cuisine, and scenic beauty with us. At NEOHO, you'll bring the vibrant life of Japan to your audience, highlighting its unique charm and traditions. Join us and transform your travels into captivating stories that connect the world to Japan!
      </p>
      <div className={styles.buttonContainer}>
        <Button
          primary={true}  // Set to true if you want to apply the primary button styling
          mailto="mailto:business@neohotech.com?subject=Influencer%20Program&body="
        >Join Us
        </Button>
      </div>
    </section>
  );
}

function MobileInfSection() {
  return (
    <section className={styles.container}>
      <img 
        loading="lazy" 
        src={bgPic1}
        className={styles.backgroundImage} 
        alt="backgroundImage"
      />
      <h1 className={styles.title}>
      Influencer Program
      </h1>
      <p className={styles.description}>
      Join us and transform your travels into captivating stories that connect the world to Japan!
      </p>
      <div className={styles.buttonContainer}>
        <Button
          primary={true}  // Set to true if you want to apply the primary button styling
          mailto="mailto:business@neohotech.com?subject=Influencer%20Program&body="
        >Join Us
        </Button>
      </div>
    </section>
  );
}

function Joinus() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  return (
    <div className="App">
      <Header />
      <main className={styles.main}> {/* Add margin at the bottom */}
        <JobProfiles />
        <div className={styles.jobCardContainer}>
          <JobCard1 />
          <JobCard2 />
          <JobCard3 />
        </div>
        {isMobile? <MobileInfSection />:<DeskInfSection />}
      </main>
      <Footer />
    </div>
  );
}

export default Joinus;
